import { useState, useCallback, useRef } from 'react'
import axios from 'axios'

export default function useClientSearch (url) {
  const [results, setResults] = useState([])
  const [searching, setSearching] = useState(false)
  const timer = useRef(null)

  const search = useCallback((query) => {
    if (timer.current) clearTimeout(timer.current)
    if (!query || query.length < 2) {
      setResults([])
      return
    }
    timer.current = setTimeout(async () => {
      setSearching(true)
      try {
        const res = await axios.get(`${url}/api/mtc-proposals/clients/search`, {
          params: { q: query }
        })
        setResults(res.data || [])
      } catch (err) {
        console.error('Client search failed:', err)
        setResults([])
      } finally {
        setSearching(false)
      }
    }, 300)
  }, [url])

  const clear = useCallback(() => {
    setResults([])
  }, [])

  return { results, searching, search, clear }
}
